import KtmbApiService from '../ktmb/KtmbApiService';

class VoiceService {
  static whitelistedEmails = [
    'psiewting@hotmail.com',
    'dloh.sage@gmail.com',
    'mandhirensing@gmail.com',
    'mohd.ismail.i@gmail.com'
    // Add more whitelisted emails here
  ];

  static isEmailWhitelisted(email) {
    return VoiceService.whitelistedEmails.includes(email);
  }

  static async isVoiceEnable(email) {
    console.log("isVoiceEnable", email);
    try {
      const ktmbApiService = new KtmbApiService();
      const isOku = await ktmbApiService.isOKU();
      if (isOku) return true;
      if (VoiceService.isEmailWhitelisted(email)) return true;
      return false;
    } catch (e) {
      return VoiceService.isEmailWhitelisted(email);
    }
  }
}
export default VoiceService;